import React from 'react';
import PropTypes from 'prop-types';

import StudyListTableRow from './StudyListTableRow';


import { StudyListTableRow2 } from './StudyListTableRow';
import Label from '../Label';

const StudyListTable = ({ tableDataSource, querying }) => {
  return (
    <div className="bg-black">
      <div className="container relative m-auto">
        <table className="w-full text-white">
          <tbody
            data-cy="study-list-results"
            data-querying={querying}
          >
            {tableDataSource.map((tableData, i) => {
              return (
                <StudyListTableRow
                  tableData={tableData}
                  key={i}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      querying: PropTypes.bool,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
};

export default StudyListTable;


export const StudyListTable2 = ({ tableDataSource, selectAll, onChangeSelection }) => {
  const baseLabelClassName = 'flex flex-col flex-1 text-white text-lg pl-1 select-none';
  const spanClassName = 'flex flex-row items-center cursor-pointer focus:outline-none';
  return (
    <div className="max-h-44 w-full overflow-x-scroll overflow-y-scroll  bg-black">
      <div className="container relative m-auto">
        <table className="w-full text-white">
          <thead>
            <tr>
              <th
                style={{ width: '5%' }}
                align="left"
              >
                <input
                  type="checkbox"
                  // value={isClicked.isClicked}
                  onChange={e => {
                    if (selectAll) {
                      selectAll(tableDataSource, e);
                    }
                  }}
                  className=""
                ></input>
              </th>
              <th
                style={{ width: '21%' }}
                align="left"
              >
                <Label
                  baseLabelClassName={baseLabelClassName}
                  spanClassName={spanClassName}
                >
                  Study Date
                </Label>
              </th>
              <th
                style={{ width: '15%' }}
                align="left"
              >
                <Label
                  baseLabelClassName={baseLabelClassName}
                  spanClassName={spanClassName}
                >
                  Modalities
                </Label>
              </th>
              <th
                style={{ width: '35%' }}
                align="left"
              >
                <Label
                  baseLabelClassName={baseLabelClassName}
                  spanClassName={spanClassName}
                >
                  Study Description
                </Label>
              </th>
              <th
                style={{ width: '20%' }}
                align="left"
              >
                <Label
                  baseLabelClassName={baseLabelClassName}
                  spanClassName={spanClassName}
                >
                  Accession
                </Label>
              </th>
            </tr>
          </thead>

          <tbody data-cy="study-list-results">
            {tableDataSource.map((tableData, i) => {
              return (
                <StudyListTableRow2
                  tableData={tableData}
                  tableDataSource={tableDataSource}
                  key={i}
                  onChangeSelection={onChangeSelection}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

StudyListTable2.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      onClickRow: PropTypes.func.isRequired,
    })
  ),
};
